/* */ 
'use strict';
Object.defineProperty(exports, "__esModule", {value: true});
exports.default = isNumeric;
var _assertString = require('./util/assertString');
var _assertString2 = _interopRequireDefault(_assertString);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}
var numeric = /^[-+]?[0-9]+$/;
function isNumeric(str) {
  (0, _assertString2.default)(str);
  return numeric.test(str);
}
module.exports = exports['default'];
